package ru.villawonka.app.presentation.screens.variantPicker.compose

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.windowInsetsPadding
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.bottomSheet.LocalBottomSheetNavigator
import ru.villawonka.app.getTelegram
import ru.villawonka.app.presentation.design.extensions.AppDragView
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.screens.variantPicker.compose.view.VariantPickerListView
import ru.villawonka.app.presentation.screens.variantPicker.model.VariantPickerItemUIModel

class VariantPickerScreen(
    private val input: Params.Input,
    private val onResult: (Params.Output) -> Unit,
) : Screen {

    sealed interface Params {

        data class Input(
            val title: String,
            val selectedItem: VariantPickerItemUIModel?,
            val items: List<VariantPickerItemUIModel>
        ) : Params

        data class Output(
            val selectedItem: VariantPickerItemUIModel
        ) : Params
    }

    @Composable
    override fun Content() {
        val bottomSheetNavigator = LocalBottomSheetNavigator.current
        var selectedItem by remember { mutableStateOf(input.selectedItem) }

        Column(
            modifier = Modifier
                .windowInsetsPadding(
                    insets = WindowInsets(
                        bottom = getTelegram()?.getSafeAreaInset()?.bottom ?: 0
                    )
                )
                .padding(
                    start = 16.dp,
                    end = 16.dp,
                    bottom = 16.dp
                )
        ) {
            AppDragView()
            AppSpacer(8.dp)
            Text(
                text = input.title,
                style = AppTextStyles.titleMediumBold,
                color = MaterialTheme.colors.onSurfacePrimary
            )
            AppSpacer(12.dp)
            VariantPickerListView(
                selectedItem = selectedItem,
                items = input.items
            ) {
                selectedItem = it
                onResult(Params.Output(it))
                bottomSheetNavigator.hide()
            }
        }
    }
}

